// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-progress {
  position: relative;
  height: 30px;
  background-color: #c3a456;
  width: 100%;
  z-index: 2;
  font-family: "Century Gothic", Gothic, sans-serif;
  color: var(--motes-dark);
  text-align: center;
  font-weight: bold;
}
.quiz-progress .progress-text {
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  line-height: 30px;
  z-index: 2;
}
.quiz-progress .progress {
  position: absolute;
  height: 100%;
  width: 70%;
  z-index: 1;
  transition: 750ms;
  background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/quiz-progress/quiz-progress.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EAEA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,iDAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;AAEI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAAR;AAGI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,sCAAA;AADR","sourcesContent":[".quiz-progress {\n    position: relative;\n    height: 30px;\n    // TODO: This is a darker tone of var(--motes-highlight-color). It should be replaced by variable.\n    background-color: #c3a456;\n    width: 100%;\n    z-index: 2;\n    font-family: \"Century Gothic\", Gothic, sans-serif;\n    color: var(--motes-dark);\n    text-align: center;\n    font-weight: bold;\n\n    .progress-text {\n        position: absolute;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        vertical-align: middle;\n        line-height: 30px;\n        z-index: 2;\n    }\n\n    .progress {\n        position: absolute;\n        height: 100%;\n        width: 70%;\n        z-index: 1;\n        transition: 750ms;\n        background-color: var(--primary-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
